import { render } from "./reservation.vue?vue&type=template&id=2594b060&scoped=true"
import script from "./reservation.vue?vue&type=script&lang=js"
export * from "./reservation.vue?vue&type=script&lang=js"

import "./reservation.vue?vue&type=style&index=0&id=2594b060&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2594b060"],['__file',"src/js/components/reservation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2594b060"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2594b060', __exports__)) {
    api.reload('2594b060', __exports__)
  }
  
  module.hot.accept("./reservation.vue?vue&type=template&id=2594b060&scoped=true", () => {
    api.rerender('2594b060', render)
  })

}


export default __exports__